import React from 'react'
import { routers } from '../../Constants/routers'

const SuccessRegister = ({ email = "@gmail.com" }) => {
    return (
        <div className="hero is-big is-grey is-bold" 
            data-background="https://dummyimage.com/1920x1080" 
            style={{ backgroundSize: 'cover', backgroundRepeat: 'no-repeat',   transform: 'scaleX(-1)', 
            // backgroundImage: `url("${require("../../assets/images/pexels-tima-miroshnichenko-5198239.jpg").default}")`
            backgroundImage: `url("https://images.pexels.com/photos/5764905/pexels-photo-5764905.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260")`
            }}>
        <div className="hero-overlay" />
        <div className="hero-body" style={{ 
            transform: 'scaleX(-1)',
             textAlign: "left" }}>
            <div className="container">
            <div className="columns is-vcentered">
                <div className="column is-6">
                <div className="card card-form careers-card-form" style={{ background: "rgba(255,255,255,0.75)" }}>
                    <div className="hero-text">
                    <h1 className="title is-1 is-bold text-primary">Registration Success.</h1>
                    <p className="subtitle is-left ">
                        You have successfully registered your account. Please 
                        login to your email to confirm your registration and start using 24Telemed.
                    </p>
                    <div className="buttons">
                        <a href={routers.auth.login}  className="button is-primary is-raised-hover mx-1">Login Now</a>
                        <a href={"http://"+email.split("@")[1]} target={"_blank"} className="button is-heavy mx-1">Go to Email</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>

    )
}

export default SuccessRegister
